import { Component, Input } from '@angular/core';
import { Product } from 'src/app/models/product.model';
import { CartService } from 'src/app/services/cart.service';
import { DrawerService } from 'src/app/components/drawer.service';

@Component({
  selector: 'app-dressing',
  templateUrl: './dressing.component.html',
  styleUrls: ['./dressing.component.css']
})
export class DressingComponent {

  @Input() dressing: Product;
  @Input() dressingHeight;

  constructor(private cartService: CartService, private drawerService: DrawerService) { }

  onAddToCart(ID, Name, Price, Picture, Category) {

    const data = {
      _id: ID,
      name: Name,
      price: Price,
      picture: Picture,
      category: Category,
      quantity: 1
    }

    this.cartService.addToCart(data);
    this.drawerService.setDrawerState(true);
  }
}
